const EXCEL_TRANSLATION_EXTENSIONS = new Set(['xls', 'xlsx'])

export const DEFAULT_TRANSLATION_FILE_TYPES = [
  'pdf', 'xls', 'xlsx', 'doc', 'docx', 'pptx', 'srt', 'epub', 'txt',
  'png', 'jpg', 'jpeg',
] as const

// 企业工作台的能力提示与 C 端保持一致。该列表只负责展示平台支持范围，
// 实际可上传格式仍由企业权益中的 fileTypes 控制。
export const ENTERPRISE_TRANSLATION_FORMAT_HINT_TYPES = [
  'pdf', 'xls', 'xlsx', 'doc', 'docx', 'pptx', 'srt', 'epub', 'txt',
  'png', 'jpg', 'jpeg', 'yaml', 'yml', 'json', 'xml', 'md',
  'html', 'htm', 'xhtm', 'xhtml',
] as const

const TRANSLATION_FILE_TYPE_DISPLAY_ORDER = [
  'pdf', 'xls', 'xlsx', 'doc', 'docx', 'pptx', 'srt', 'epub', 'txt',
  'png', 'jpg', 'jpeg', 'webp', 'yaml', 'yml', 'json', 'xml', 'md',
  'html', 'htm', 'xhtm', 'xhtml', 'po', 'dxf',
]

export const isExcelTranslationExtension = (extension: unknown) => {
  return EXCEL_TRANSLATION_EXTENSIONS.has(String(extension ?? '').toLowerCase())
}

export const includeLegacyExcelType = (fileTypes: string[]) => {
  const expandedTypes = [...fileTypes]
  const xlsxIndex = expandedTypes.indexOf('xlsx')

  if (xlsxIndex !== -1 && !expandedTypes.includes('xls')) {
    expandedTypes.splice(xlsxIndex + 1, 0, 'xls')
  }

  return expandedTypes
}

/**
 * 将企业权益中的格式配置规范为用户可读列表。
 * doc/docx、xls/xlsx 在后端分别属于同一项能力，任一别名启用时都应完整展示并允许选择。
 */
export const getTranslationFileTypeDisplayList = (fileTypes?: string | string[] | null) => {
  const source = (Array.isArray(fileTypes) ? fileTypes : String(fileTypes || '').split(','))
    .map(item => String(item).trim().replace(/^\./, '').toLowerCase())
    .filter(Boolean)
  const normalized = source.length ? source : [...DEFAULT_TRANSLATION_FILE_TYPES]
  const enabled = new Set(normalized)

  if (enabled.has('doc') || enabled.has('docx')) {
    enabled.add('doc')
    enabled.add('docx')
  }
  if (enabled.has('xls') || enabled.has('xlsx')) {
    enabled.add('xls')
    enabled.add('xlsx')
  }

  const ordered = TRANSLATION_FILE_TYPE_DISPLAY_ORDER.filter(type => enabled.delete(type))
  return ordered.concat([...enabled])
}
